var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1018_172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.5,
    width: 44,
    height: 44,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8499 26.4999C26.8499 24.7602 28.2602 23.3499 29.9999 23.3499C31.7396 23.3499 33.1499 24.7602 33.1499 26.4999C33.1499 28.2396 31.7396 29.6499 29.9999 29.6499C28.2602 29.6499 26.8499 28.2396 26.8499 26.4999ZM29.9999 21.6499C27.3213 21.6499 25.1499 23.8213 25.1499 26.4999C25.1499 29.1785 27.3213 31.3499 29.9999 31.3499C32.6785 31.3499 34.8499 29.1785 34.8499 26.4999C34.8499 23.8213 32.6785 21.6499 29.9999 21.6499ZM24.8499 36.4166C24.8499 36.0136 25.1786 35.4978 26.2183 35.0387C27.2078 34.6017 28.5841 34.3499 29.9999 34.3499C31.3956 34.3499 32.7708 34.643 33.7678 35.1046C34.2668 35.3356 34.6327 35.5911 34.8629 35.8377C35.0845 36.0752 35.1475 36.2655 35.1498 36.4084C35.1418 36.4299 35.105 36.498 34.9626 36.6087C34.7442 36.7785 34.3796 36.9615 33.8649 37.1269C32.8445 37.4548 31.4362 37.6499 29.9999 37.6499C28.3014 37.6499 26.9033 37.452 25.9612 37.1315C25.4875 36.9703 25.181 36.7954 25.0076 36.6424C24.8488 36.5023 24.8498 36.4285 24.8499 36.4173L24.8499 36.4166ZM35.1518 36.4009C35.152 36.401 35.1518 36.4029 35.1505 36.4067C35.1509 36.4028 35.1516 36.4009 35.1518 36.4009ZM29.9999 32.6499C28.4157 32.6499 26.792 32.9269 25.5315 33.4836C24.3213 34.018 23.1499 34.9606 23.1499 36.4166C23.1499 37.0455 23.4675 37.5506 23.8828 37.9171C24.2876 38.2743 24.8248 38.5405 25.4136 38.7409C26.5965 39.1434 28.1984 39.3499 29.9999 39.3499C31.5636 39.3499 33.1553 39.1406 34.385 38.7454C34.9952 38.5493 35.5682 38.2912 36.0059 37.9509C36.4403 37.6133 36.8499 37.1033 36.8499 36.4166C36.8499 35.727 36.536 35.1388 36.1057 34.6777C35.6796 34.2212 35.108 33.8517 34.482 33.5619C33.229 32.9818 31.6042 32.6499 29.9999 32.6499ZM36.1538 30.4184C36.1989 29.9511 36.6142 29.6088 37.0814 29.6538C38.2956 29.7708 39.4221 30.0864 40.2733 30.5787C41.0977 31.0554 41.8499 31.8199 41.8499 32.8732C41.8499 33.4191 41.641 33.9169 41.2348 34.3125C40.8518 34.6854 40.3291 34.9348 39.7317 35.1042C39.2801 35.2322 38.8102 34.9699 38.6821 34.5182C38.5541 34.0666 38.8164 33.5967 39.2681 33.4686C39.7157 33.3417 39.9429 33.1977 40.0487 33.0946C40.1313 33.0142 40.1499 32.9535 40.1499 32.8732C40.1499 32.7165 40.0327 32.4033 39.4223 32.0503C38.8388 31.7129 37.9652 31.4469 36.9184 31.346C36.4511 31.301 36.1088 30.8856 36.1538 30.4184ZM37.9999 21.6499C37.5305 21.6499 37.1499 22.0305 37.1499 22.4999C37.1499 22.9693 37.5305 23.3499 37.9999 23.3499C38.9112 23.3499 39.6499 24.0886 39.6499 24.9999C39.6499 25.9112 38.9112 26.6499 37.9999 26.6499C37.5305 26.6499 37.1499 27.0305 37.1499 27.4999C37.1499 27.9693 37.5305 28.3499 37.9999 28.3499C39.8501 28.3499 41.3499 26.8501 41.3499 24.9999C41.3499 23.1497 39.8501 21.6499 37.9999 21.6499Z",
    fill: "#5E72E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1018_172",
    x: 0,
    y: 0.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1018_172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1018_172",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customersIcon.57dcd85b5ea4d6bb9ef1d811233e1d19.svg";
export { ForwardRef as ReactComponent };